// saving items

import { collection, doc, getDoc, getDocs, orderBy, query, setDoc, updateDoc } from "firebase/firestore"
import { firestore } from "../firebase.config"

export const saveItem = async (data)=>{
    await setDoc(doc(firestore,'foodItems', `${Date.now()}`), data, {merge: true})
}
export const saveOrder = async (data)=>{
    await setDoc(doc(firestore,'userOrder', `${Date.now()}`), data, {merge: true})
}
export const saveUser = async (Uid,data)=>{
    await setDoc(doc(firestore,'userDetail', `${Uid}`), data, {merge: true})
}

export const saveUserDetail = async (id,data)=>{
    await updateDoc(doc(firestore,'userDetail', `${id}`), data)

}
// GET DATA

export const getAllFoodItems = async ()=>{
    const items = await getDocs(query(collection(firestore,"foodItems"), orderBy("id","desc")))

    return items.docs.map((doc)=> doc.data())
}
export const getUserOrders = async ()=>{

    const items = await getDocs(query(collection(firestore,"userOrder"), orderBy("id","desc")))

    return items.docs.map((doc)=> doc.data())
}